// extracted by mini-css-extract-plugin
module.exports = {"root":"blog_image-module--root--1FhuA","img":"blog_image-module--img--2ZYgZ"};